import React from 'react'
import { useTranslation } from 'react-i18next'
import { ReportProvidersProvidedTable } from './ReportProvidersProvidedTable'
import { ReportProvidersPurchasedElectricityTable } from './ReportProvidersPurchasedElectricityTable'
import { Section } from '../../common/Section'
import { ReportSolarPanelsAndBatteriesTable } from './ReportSolarPanelsAndBatteriesTable'
import { Provider } from '../../../calculators/providers/common/Provider'
import { producedEnergySubCategories } from '../../../provider/result-categories'

type Props = {
  providers: Provider[]
}

export function ReportEnergySystemsSection({
  providers,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <Section title={t('report.energySystems')}>
      {producedEnergySubCategories.map((subCategory) => (
        <ReportProvidersProvidedTable
          key={`provider-provided-by-${subCategory.nameKey}-table`}
          providers={providers}
          subCategory={subCategory}
        />
      ))}

      <ReportProvidersPurchasedElectricityTable providers={providers} />

      <ReportSolarPanelsAndBatteriesTable providers={providers} />
    </Section>
  )
}
